import { useState, useEffect } from "react";
import UserData from "../Controls/UserData";
import "../../style/scss/Recruit.scss";
import { Link, useParams, useLocation } from "react-router-dom";
import BreadCrumb from "../Controls/BreadCrumb";
import EmployerRoleListItem from "../ListItems/EmployerRoleListItem";
import JobPostingListItem from "../ListItems/JobPostingListItem";
import Spinner from "../Controls/Spinner";
import PackageListItem from "../ListItems/PackageListItem";
import PackageEditModal from "../Modals/PackageEditModal";
import JobPostingEditModal from "../Modals/JobPostingEditModal";
import Help from "../Controls/Help";
import API from "@src/API.js";
import { MdAddBox } from "react-icons/md";

export default function EmployerRecruitEdit(props) {
  const { id: idStr } = useParams();
  const location = useLocation();
  const employerID = Number.parseInt(idStr, 10) || 0;

  const [admin, Update] = useState({ Admins: [] });
  const [breadcrumb, UpdateBreadcrumb] = useState([]);
  const [lookups] = useState(UserData.Lookups());
  const [processing, setProcessing] = useState(false);
  const [packageModalId, setPackageModalId] = useState(null);
  const [jobPostingModalId, setJobPostingModalId] = useState(() => {
    const fromState = location.state?.jobPostingModalId;
    return fromState != null ? Number(fromState) || 0 : null;
  });
  const [jobPostingRoleId] = useState(() => Number(location.state?.roleId) || 0);

  useEffect(() => {
    getEmployerAdminAsync(employerID);
    const bc = [...(location.state?.breadcrumb || [])];
    bc.push({ label: "Recruitment", route: location.pathname });
    UpdateBreadcrumb(bc);
  }, [location.pathname, employerID]);

  async function getEmployerAdminAsync(id) {
    setProcessing(true);
    const resp = await API.getAsync("/Employer/" + id + "/Admin");
    if (resp && resp.ok) {
      Update(resp.jsonData);
    }
    setProcessing(false);
  }

  async function closePackageModal() {
    setPackageModalId(null);
    await getEmployerAdminAsync(employerID);
  }

  async function closeJobPostingModal() {
    setJobPostingModalId(null);
    await getEmployerAdminAsync(employerID);
  }

  return (
    <div className="pagebody">
      <BreadCrumb props={breadcrumb} />
      <div className="tabbody">
        <h2>Employer Administration: {admin.EmployerName}</h2>
        <div className="tabsection">
          <div className="listTitle">
            <span>Packages</span>
            <Help id="2122" />
            <div className="listTitleIcons">
              <MdAddBox
                data-testid="package-add"
                role="button"
                aria-label="Add package"
                onClick={() => setPackageModalId(0)}
              />
            </div>
          </div>
          <div className="sectionData">
            <ul>
              {(admin.Packages || []).map((pkg) => (
                <li key={pkg.ID || pkg.id}>
                  <PackageListItem
                    package={pkg}
                    employerID={employerID}
                    onEdit={(id) => setPackageModalId(id)}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="tabsection">
          <div className="listTitle">
            <span>
              Roles
              <Help id="2120" />
            </span>
            <div className="listTitleIcons">
              <Link
                to="/employerRoleEdit/0"
                state={{
                  breadcrumb: breadcrumb,
                  employer: { ID: employerID, Name: admin.EmployerName },
                }}
              >
                <MdAddBox />
              </Link>
            </div>
          </div>
          <div className="sectionData">
            <ul>
              {(admin.Roles || []).map((role) => (
                <li key={role.ID || role.id}>
                  <EmployerRoleListItem
                    employerID={employerID}
                    employerName={admin.EmployerName}
                    role={role}
                    breadcrumb={breadcrumb}
                    postings={admin.Postings}
                    employmentTypes={lookups.employmentType}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="tabsection">
          <div className="listTitle">
            <span>
              Job Postings
              <Help id="2121" />
            </span>
            <div className="listTitleIcons">
              <MdAddBox
                data-testid="job-posting-add"
                role="button"
                aria-label="Add job posting"
                onClick={() => setJobPostingModalId(0)}
              />
            </div>
          </div>
          <div className="sectionData">
            <ul>
              {(admin.Postings || []).map((jobPost) => (
                <li key={jobPost.ID || jobPost.id}>
                  <JobPostingListItem
                    post={jobPost}
                    employmentTypes={lookups.employmentType}
                    onEdit={(id) => setJobPostingModalId(id)}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <Spinner show={processing || props.processing} />
      {packageModalId !== null ? (
        <PackageEditModal
          packageId={packageModalId}
          employerId={employerID}
          onClose={closePackageModal}
        />
      ) : null}
      {jobPostingModalId !== null ? (
        <JobPostingEditModal
          jobPostingId={jobPostingModalId}
          employerId={employerID}
          employerName={admin.EmployerName}
          roleId={jobPostingRoleId}
          roles={admin.Roles || []}
          packages={admin.Packages || []}
          onClose={closeJobPostingModal}
        />
      ) : null}
    </div>
  );
}
